
import {Component, Mixins, Prop, Vue} from "vue-property-decorator";
import PickerInputMixin from "@/mixins/PickerInputMixin.vue";
import MahkemeForm from "@/components/forms/MahkemeForm.vue";
import {MahkemeEntity} from "@/entity/MahkemeEntity";

@Component({
  components: {MahkemeForm},
})
export default class MahkemeSecim extends Mixins(PickerInputMixin) {
  @Prop() hideDetails!: string | boolean;
  @Prop({default: null}) item!: MahkemeEntity | null;
  @Prop({type: Object}) defaultValues!: any;
  @Prop({required: false}) alacakBilgisi?: any;

  readonly emptyAlacakBilgisiStub = { mahkeme_id: null as number | null, ozel_mahkeme_isim: "" };

  dialog = false;
  items!: Array<MahkemeEntity>;

  get isHideDetails() {
    return this.hideDetails || this.hideDetails === "";
  }

  /**
   * v-model id veya tam mahkeme nesnesi; store listesinde yoksa (PickerInputMixin update silmesin diye) listeye eklenir.
   */
  private resolveMahkemeIdAndEntity(): { id: number | null; entity: MahkemeEntity | null } {
    const fromProp = this.item || this.alacakBilgisi?.mahkeme;
    if (this.value && typeof this.value === "object" && "id" in this.value) {
      const entity = this.value as MahkemeEntity;
      const id = Number(entity.id);
      return { id: Number.isFinite(id) ? id : null, entity };
    }
    const rawId = this.alacakBilgisi?.mahkeme_id ?? this.value;
    if (rawId == null || rawId === "") {
      return { id: null, entity: null };
    }
    const id = Number(rawId);
    if (!Number.isFinite(id)) {
      return { id: null, entity: null };
    }
    const entity =
      fromProp && Number(fromProp.id) === id ? (fromProp as MahkemeEntity) : null;
    return { id, entity };
  }

  private mergeMahkemeIntoStoreListIfMissing(list: Array<MahkemeEntity>): void {
    const { id, entity } = this.resolveMahkemeIdAndEntity();
    if (id == null || entity == null || Number(entity.id) !== id) {
      return;
    }
    if (!list.some((m) => m.id === id)) {
      list.push(entity);
    }
  }

  async mounted() {
    try {
      await this.$store.dispatch("getMahkemeler");
    } catch (e) {
      console.error("Mahkemeler yüklenemedi:", e);
    }
    const list = this.$store.state.mahkemeler as Array<MahkemeEntity>;
    this.mergeMahkemeIntoStoreListIfMissing(list);
    this.$store.commit("resortMahkemeler");
    this.items = list;
    await this.$nextTick();
    (this as Vue & { update: () => void }).update();
  }

  /*async load() {
    await this.$http.get('/api/v1/mahkeme/').then(response => {
      this.items = response.data;
    })
  }*/

  onSelectedItemChanged() {
    this.selectedId = this.value;
    this.$emit('mahkemeData', this.selectedItem);
    this.input();
  }

  async saveMahkeme(eklenenMahkeme: any) {
    this.dialog = false;

    const yeniMahkeme = eklenenMahkeme.mahkeme;
    this.items.push(yeniMahkeme);
    this.$store.commit('resortMahkemeler');
    this.selectedItem = yeniMahkeme;

    this.$emit('mahkemeData', yeniMahkeme);
    this.input();
  }
}
